/*
 * @Author: Dom
 * @Date: 2022-05-26 10:00:26
 * @LastEditTime: 2022-05-26 10:04:57
 * @LastEditors: Dom
 * @FilePath: \seller-web\src\services\country.ts
 */
import request from '@/utils/request'

export async function getCountry(): Promise<any>{
    return request({
        url: '/seller/v1/country/getAllCountry',
        method: 'GET'
    })
}
